import React from 'react';
import slider1 from '../../../assets/images/behavioral_therapy/slider_1.jpg';
import slider2 from '../../../assets/images/behavioral_therapy/slider_2.jpg';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';
const images = [
  {
    src: slider1,
    alt: 'Mantal health climbing in Wasilla physical therapy session',
  },
  {
    src: slider2,
    alt: 'Physical health stretching exercise in Wasilla, AK',
  },
];

function MentalHealth() {
  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div>
        <h4 className="text-[36px] sm:text-[42px] md:text-[52px] 2xl:text-[58px] 2xl:leading-[54px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
          Mental Health and <br /> Behavioral Therapy
        </h4>
      </div>
      <div className="flex flex-col lg:flex-row justify-between w-full gap-4 xl:gap-32">
        <div className="flex-1 flex flex-col items-start justify-between gap-4 sm:gap-6 lg:gap-8 font-custom text-lg md:text-xl 2xl:text-2xl text-secondary">
          <h2 className="text-[#7B54A2] text-[24px] sm:text-[26px] md:text-[28px] font-bold leading-8 sm:leading-10 ">
            Counseling services for your child <br /> and the entire family.
          </h2>
          <p>
            We all want our children to be happy and healthy, we want them to
            thrive and advance, while meeting milestones on-time. Every child is
            different though, and here at Guidepost Pediatric Therapies, we will
            do our best to help you and your child work through difficult times.
          </p>
          <p>
            Mental health is an important part of overall health for all of us,
            children included! The earlier issues are addressed and treatment is
            started, the more effective it can be.
            <br />
            <strong>
              Early treatment can help prevent more severe, lasting problems as
              a child grows up.
            </strong>
          </p>

          <p>
            It can be difficult to know whether the troubling behavior in a
            child is just part of growing up or if there’s a problem that should
            be addressed professionally. If there are behavioral signs that last
            weeks or months, and if they clearly interfere with the child’s
            daily life at home, at school, or with peers, please reach out for
            support.
          </p>
        </div>
        <div className="flex-1 flex justify-center overflow-hidden relative">
          <CrossFadeImageSlider
            width="w-[90vw] md:w-[700px] 2xl:w-[500px] "
            height="h-[600px] 2xl:h-[670px]"
            images={images}
            // rounded="rounded-2xl"
          />
        </div>
      </div>
    </div>
  );
}

export default MentalHealth;
